import "./bck.scss";

import m from "mithril";
// import "noty/lib/themes"
import helper from "../helper";
import cache from "./cache";
import tools from "./tools/tools";
import Btn from "../app/components/button/index";
//import Noty from "noty";
import pf from "./pf";
import loader from "./loader";
import standardLoader from "../app/components/standard-loader/standard-loader";
import cacomponent from "../app/custom-action-buttons/custom-action-component";
import svg from "./svg";
import modal from "./modal/modal";
import tc from "./prasora-cell/prasora-cell";
import datepicker from "./datepicker/datepicker";
import wsi from "./prasora-wsi/prasora-wsi";
import popupblock from "../app/components/popupblock/popupblock";
import wsi2 from "./prasora-wsi2/prasora-wsi2";
import cb from "./checkbox/cb";
import z from "./zipcelx/zipcelx";
import workermanager from "./worker-manager";
import classnames from "classnames";
import mmtjs from "../mmtjs";
import assistant from "../askbar/assistant";
import {Icons, Icon, Size, PopoverMenu, Button, MenuItem, MenuDivider} from "./tools/constructui";
import CustomFormatter from "../custom-formatter/custom-formatter";
// import {filter} from "jszip";

let bck = () => {
	const cac = cacomponent();
	let isJuniorBlock = false;
	let selectedall = false;
	let parentrow = undefined;
	let juniors = [];
	let showrowdetail = undefined;
	let firstRequest = true;
	let isAdmin = false;
	let hiddenCols = {};
	const {askbar, askbarcomp} = assistant();
	let hasSearch = false;
	let maxRowsExportable = 2500;
	let appcode = null;
	let selectsingleonly = false;
	let tempPageNumber = 1;
	let prefilter = undefined;
	let ws = null;
	let wstype = 2;
	let wsTitlesSlanted = false;
	let refreshtime = 0;
	let cachetime = 0;

	let category = null;
	let groups = null;
	let tact = null;
	let hideHeader = false;
	let HasNoDataAction = null;
	// let dateFormats = "YYYY-MM-DD HH:mm";
	let pagesize = 5;
	let pagenum = 1;
	let tid = null;
	let prid = null;
	let initialted = false;
	let cols = [];
	let csum = {};
	let tableInfo = {};
	let showfoot = false;
	let noOfPages = 0;
	let numberOfRows = 0;
	let ds = null;
	let fs = null;
	let editData = {};
	let downloadingtable = false;
	let showasfields = false;
	let stripdata = false;

	let showpagemanager = true;
	let showColumnOptions = false;
	let showfilterOptions = false;
	let showShareOptions = false;

	let hiddenFieldID = null;
	let hiddenFieldColumn = null;
	let hiddenSelectedField = null;
	let currentlySelectedRows = new Set();

	let updatingfields = {};
	let waitforupdatingfields = false;
	let fixed_editable = false;

	const {FunctionList, ExecuteFunction} = CustomFormatter();
	// console.log({list: FunctionList(), exe: ExecuteFunction("test1", 2)});
	// ExecuteFunction("test1", 2).then((res) => console.log({res}));

	function SelectCurrentRowValue(val, add) {
		// console.log("setting", {val, add});
		if (val) {
			if (!hiddenSelectedField) {
				hiddenSelectedField = document.getElementById(hiddenFieldID);
			}

			if (hiddenSelectedField) {
				if (selectsingleonly) currentlySelectedRows.clear();
				//console.log({selectsingleonly, currentlySelectedRows});

				if (add) currentlySelectedRows.add(val);
				else currentlySelectedRows.delete(val);

				hiddenSelectedField.value = Array.from(currentlySelectedRows).join();

				var buttonClassID = hiddenFieldID.replace("selectedRecords__", ".dependency-on-block-");

				let buttonsLinked = document.querySelectorAll(buttonClassID);

				// console.log({hiddenFieldID, buttonClassID, buttonsLinked});

				buttonsLinked.forEach((b) => {
					// console.log({b});
					let blockids = b.getAttribute("dependency-hidden-fields").split(",");
					let keepinvisible = false;
					blockids.forEach((hid) => {
						var nhf = document.getElementById(`selectedRecords__${hid}`);
						if (nhf) {
							if (!nhf.value) keepinvisible = true;
						} else keepinvisible = !hiddenSelectedField.value;
					});
					if (!keepinvisible) {
						if (b.classList.contains("dependency-hidden")) {
							b.classList.remove("dependency-hidden");
						}
					} else {
						if (!b.classList.contains("dependency-hidden")) {
							b.classList.add("dependency-hidden");
						}
					}
				});
			}
		}
		// console.log(currentlySelectedRows, hiddenSelectedField.value);
	}

	function JSDateToExcelDate(inDate) {
		var returnDateTime = 25569.0 + (inDate.getTime() - inDate.getTimezoneOffset() * 60 * 1000) / (1000 * 60 * 60 * 24);
		return returnDateTime.toString().substr(0, 5);
	}

	async function DownloadTable() {
		// console.log("requested for download");
		await GetBlockData(true).then((r) => {
			// console.log("received data to export", r);
			let colData = cols
				.filter((a) => !a.hide)
				.map((a) => {
					return {
						value: a.caption.replace(/_/g, " "),
						type: "string", // (a.isNumber ? "number" : "string")
					};
				});

			let rowData = r.rows.map((r) => {
				return cols
					.filter((a) => !a.hide)
					.map((a) => {
						if (r[a.name].value)
							return {
								value: a.isDate ? JSDateToExcelDate(new Date(r[a.name].value)) : r[a.name].value.toString(),
								type: a.isNumber || a.isDate ? "number" : "string",
							};
						else
							return {
								value: "",
								type: "string",
							};
					});
			});

			let finalData = [colData, ...rowData];

			const config = {
				filename: `${ds.title ? ds.title : "download"}_${mmtjs().format("YYYY MM DD hh:mm")}`,
				sheet: {
					data: finalData,
				},
			};

			// console.log("finaldata", finalData);
			z(config);
		});
	}

	async function CopyTable() {
		downloadingtable = true;
		await GetBlockData(true).then((r) => {
			let colData = cols.filter((a) => !a.hide).map((a) => a.caption.replace(/_/g, " "));

			let rowData = r.rows.map((r) =>
				cols
					.filter((a) => !a.hide)
					.map((a) => {
						if (a.customformat) {
							return null;
						} else {
							if (r[a.name].value) return r[a.name].value.toString();
							else return r[a.name].value;
						}
					})
			);

			let finalData = [colData, ...rowData];

			pf.CreateTableElementAndCopy(finalData);

			downloadingtable = false;
			m.redraw();
		});
	}

	/* #region  DataTable Management */
	function toggleSort(c) {
		cols.forEach(function (obj) {
			if (obj.name == c) {
				obj.sort--;
				if (obj.sort == -2) obj.sort = 1;
			} else obj.sort = 0;
		});

		Refresh();
	}

	function toggleFilter() {
		tableInfo.showFilter = !tableInfo.showFilter;
		Refresh();
	}

	function PageIncrease() {
		PageImpact(1);
		Refresh();
	}

	function PageDecrease() {
		PageImpact(-1);
		Refresh();
	}

	function PageImpact(i) {
		pagenum += i;
		noOfPages = Math.ceil(numberOfRows / pagesize);
		if (pagenum > noOfPages) {
			pagenum = noOfPages;
		}
		if (pagenum < 1) pagenum = 1;
		tempPageNumber = pagenum;
	}

	function DirectSetPageNum() {
		if (tempPageNumber) {
			pagenum = tempPageNumber;
			noOfPages = Math.ceil(numberOfRows / pagesize);
			if (pagenum > noOfPages) {
				pagenum = noOfPages;
			}
			if (pagenum < 1) pagenum = 1;
			DelayedRefresh();
			tempPageNumber = pagenum;
		}
	}

	function updateFilter(name, filterText) {
		let needRefresh = false;

		cols.forEach(function (obj) {
			if (obj.name == name) {
				if (obj.filter != filterText) {
					obj.filter = filterText;
					needRefresh = true;
				}
			}
		});

		if (needRefresh) DelayedRefresh();
	}

	let prefetchpages = 3;
	let prefetchedpages = {searchkey: undefined, search: {}, standard: {}};
	let firstPageRequest = null;
	let prefetchKey = "standard";
	let page1Done = false;

	function Reset() {
		prefetchedpages.search = {};
		prefetchedpages.standard = {};
		page1Done = false;
		pagenum = 1;
		firstPageRequest = null;
	}

	async function GetBlockData(all) {
		let result = null;
		let colsearch = {};
		let colsort = {};

		if (ds) {
			cols
				.filter((a) => !!a.filter)
				.forEach((a) => {
					hasSearch = true;
					colsearch[a.name] = a.filter;
				});
			cols
				.filter((a) => !!a.sort)
				.forEach((a) => {
					hasSearch = true;
					colsort[a.name] = a.sort;
				});
		}

		if (prefilter) {
			hasSearch = true;
			colsearch = prefilter;
		}

		if (hasSearch) {
			let searchkey = `${JSON.stringify(colsearch)}${JSON.stringify(colsort)}`;
			if (searchkey != prefetchedpages.searchkey) {
				prefetchedpages.searchkey = searchkey;
				prefetchKey = "search";
				Reset();
			}
		} else prefetchKey = "standard";

		// console.log("Searching", colsearch);

		// await GetPageData(all ? 1 : pagenum, all ? numberOfRows : pagesize, {
		//   tid: tid,
		//   tact: tact,
		//   prid: prid,
		//   search: colsearch,
		//   category: category,
		//   sort: colsort,
		//   groups: groups,
		//   textonly: all,
		// })

		let isFirstRequest = firstRequest;
		firstRequest = false;

		// console.log({parentrow});

		await pf
			.APIAction(
				"GetBlockDataForUT",
				{
					tid: tid,
					tact: tact,
					prid: prid,
					search: colsearch,
					category: category,
					sort: colsort,
					groups: groups,
					pagesize: all ? numberOfRows : pagesize,
					pagenum: all ? 1 : pagenum,
					textonly: all,
					isFirstRequest,
					row: parentrow,
				},
				function (xhr) {
					searchXHR = xhr;
					// console.log("xhr", searchXHR);
				}
			)
			.then((r) => {
				result = r;
				// console.log({result: JSON.stringify(result)});
				if (r.juniors) {
					juniors = r.juniors;
					// console.log({result});
					showrowdetail = r.juniors && r.juniors.length > 0;
				}
				isAdmin = r.isadmin;
				if (r && r.cols.length > 0)
					cache.set(appcode, tid, {
						r: result,
						ps: pagesize,
						pn: pagenum,
						nr: numberOfRows,
					});
			});

		return result;
	}

	function ProcessColumns() {
		cols.forEach((col) => {
			ds.rows.forEach((row) => {
				ProcessRowColumn(col, row);
			});
		});
	}

	function ProcessRowColumn(col, row) {
		if (col.isDate) {
			if (row[col.name].value) {
				var tempValue = row[col.name].text;
				// console.log(tempValue);
				var m = mmtjs(row[col.name].value);
				if (m.isValid()) {
					if (col.isTime) {
						row[col.name].text = m.format("D MMM YYYY HH:mm");
					} else row[col.name].text = m.format("D MMM YYYY");
				}
			}
		}
		if (col.isBool) {
			if (row[col.name].value) {
				if (row[col.name].value === true) {
				}
				if (row[col.name].value == "True") {
					row[col.name].value = true;
				}
				if (row[col.name].value == "False") {
					row[col.name].value = false;
				}
			} else {
				if (row[col.name].value === false) {
				} else row[col.name].value = false;
			}
		}

		// console.log("processed row col", row[col.name].value);
	}

	async function Process(backend) {
		if (tableInfo.ajaxcall) {
			abortPreviousSearch();
			tableInfo.ajaxcall = false;
		}

		if (!backend) {
			tableInfo.ajaxcall = true;
			m.redraw();
		}
		return await GetBlockData().then((result) => {
			ProcessResultFromAPI(result);
			// console.log("processed", {refreshtime});
			if (refreshtime > 0)
				setTimeout(() => {
					// Code to run after 100 ms
					// console.log("refreshing");
					Refresh(backend);
				}, refreshtime * 1000);
		});
	}

	function ProcessResultFromAPI(result, iscache) {
		ds = result;
		if (ds && ds.nodata) {
			if (!iscache && !hasSearch) HasNoDataAction();
		} else {
			if (ds?.rows) {
				if (ds.count > ds.rows.length) {
					tableInfo.partialTable = true;
				} else tableInfo.partialTable = false;
			} else {
				// console.log("check for no data in block id", tid);
			}
			// console.log({ds});

			if (ds.hideheader) hideHeader = true;
			if (cols) {
				let newcols = ds.cols.map((n) => {
					let p = cols.find((a) => a.name == n.name);
					if (p) {
						n.filter = p.filter;
						n.sort = p.sort;
						n.hide = hiddenCols[p.name];
					}
					return n;
				});
				cols = newcols;
			} else cols = ds.cols;
			tableInfo.showFilter = ds.showfilter && !stripdata;
			tableInfo.showEditable = ds.hasedit && !stripdata;
			showfoot = cols.some((a) => a.sum);

			ws = ds.ws;
			// console.log(ws);
			if (ws) {
				wstype = ws.wstype;
				// console.log("received wstype", wstype);
			}

			tableInfo.stateReady = true;
			tableInfo.ajaxcall = false;
			tableInfo.stateLoading = false;
			ProcessColumns();

			if (tableInfo.partialTable) {
				if (fs)
					fs.forEach((r, i) => {
						ds.cols.forEach((c) => {
							if (editData[r[c.name].nf]) {
								ds.rows[i][c.name].text = fs[i][c.name].text;
								ds.rows[i][c.name].value = fs[i][c.name].value;
							}
						});
					});
				fs = ds.rows;
				numberOfRows = ds.count;
				PageImpact(0);
				m.redraw();
			} else {
				// console.log(ds.count, ds.rows.length);
				if (ds.count > ds.rows.length) {
					fs = ds.rows;
					tableInfo.partialTable = true;
					numberOfRows = ds.count;
					PageImpact(0);
					m.redraw();
				} else {
					fs = ds.rows;
					tableInfo.partialTable = false;
					numberOfRows = ds.count;
					PageImpact(0);
					m.redraw();
				}
			}
		}
		m.redraw();
	}

	async function GetDataFromCache() {
		// console.log("getting cache");
		return cache.get(appcode, tid).then((result) => {
			if (!ds) {
				if (result) {
					let {r, ps, pn, nr} = result;
					if (r && r.cols && r.rows && r.rows.length > 0) {
						if (r.count > 0) {
							result = r;
							// cols = c;
							pagesize = ps;
							pagenum = pn;
							numberOfRows = nr;

							r.hasedit = false;
							// console.log("cache");

							ProcessResultFromAPI(result, true);
							tableInfo.stateLoading = true;
							m.redraw();
						}
					}
				}
			}
		});
	}

	let timeout = null;

	function DelayedRefresh(reset) {
		//let ts = Date.now();
		tableInfo.stateLoading = true;
		if (timeout) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(function () {
			Refresh(true, reset);
		}, 800);
	}

	async function RefreshAsync() {
		Refresh(true);
	}

	var searchXHR = null;

	function abortPreviousSearch() {
		if (searchXHR !== null) {
			searchXHR.abort();
			// console.log("previous search cancelled");
		}
		searchXHR = null;
	}

	function Refresh(backend, reset) {
		if (reset) Reset();
		tableInfo.stateLoading = true;
		Process(backend);
	}
	/* #endregion */

	async function UpdateField(local, nf, result, value, links) {
		// console.log("updating fields ", {local, nf, result, value, links});

		let tgtCellRowCol = {row: undefined, col: undefined, set: false};

		for (let ri = 0; ri < fs.length; ri++) {
			for (let ci = 0; ci < ds.cols.length; ci++) {
				if (fs[ri][ds.cols[ci].name].nf == nf) {
					// if (result) console.log("updated from backend", {nf, value});
					// else console.log("updated from local", {nf, value});
					tgtCellRowCol.row = ri;
					tgtCellRowCol.col = ds.cols[ci];
					tgtCellRowCol.set = true;
				}
			}
		}

		if (tgtCellRowCol.set) {
			tgtCellRowCol.old = {
				value: fs[tgtCellRowCol.row][tgtCellRowCol.col.name].value,
				text: fs[tgtCellRowCol.row][tgtCellRowCol.col.name].text,
				links: fs[tgtCellRowCol.row][tgtCellRowCol.col.name].links,
			};
			if (value) fs[tgtCellRowCol.row][tgtCellRowCol.col.name].value = value.nv;
			if (result) if (result.text) fs[tgtCellRowCol.row][tgtCellRowCol.col.name].text = result.text;
			if (links) fs[tgtCellRowCol.row][tgtCellRowCol.col.name].links = links;
			ProcessRowColumn(tgtCellRowCol.col, fs[tgtCellRowCol.row]);
		}

		if (!local) {
			updatingfields[nf] = updatingfields[nf] ?? 0 + 1;
			waitforupdatingfields = true;
			const tokenurl = document.getElementById("singleuselatestpagetokenurl").value;
			const token = document.getElementById("singleuselatestpagetoken").value;

			await pf
				.APIAction("UpdateValueForNF", {
					tact: tact,
					nf: nf,
					value: value,
					needlinks: true,
					tokenurl,
					token,
				})
				.then((r) => {
					if (!r.success) {
						if (r.error) {
							askbar.ShowConfirmMessage(r.error, "ERROR");
							waitforupdatingfields = false;
							m.redraw();
						}
					} else {
						result = r;

						// console.log("starting with", {updatingfields});
						updatingfields[nf] = (updatingfields[nf] ?? 1) - 1;
						// console.log("reduced count", {updatingfields});
						if (updatingfields[nf] <= 0) delete updatingfields[nf];
						// console.log("deleted if required", {updatingfields});
						CheckForUpdatingFields();
					}
				})
				.catch((r) => {
					console.log("some error in updating field. so, saving it locally. catch", {r});
					workermanager.UpdateField(nf, "UpdateValueForNF", {
						tact,
						nf,
						value,
					});
				});
			if (result?.success) {
				// for (let ri = 0; ri < fs.length; ri++) {
				// 	for (let ci = 0; ci < ds.cols.length; ci++) {
				// 		if (fs[ri][ds.cols[ci].name].nf == nf) {
				// 			// console.log(value, fs[ri][ds.cols[ci].name]);
				// 			fs[ri][ds.cols[ci].name].nf = result.nf;
				// 			fs[ri][ds.cols[ci].name].value = value;
				// 			fs[ri][ds.cols[ci].name].text = result.text;
				// 			if (result.links) fs[ri][ds.cols[ci].name].links = result.links;
				// 			ProcessRowColumn(ds.cols[ci], fs[ri]);
				// 			m.redraw();
				// 		}
				// 	}
				// }

				if (tgtCellRowCol.set) {
					fs[tgtCellRowCol.row][tgtCellRowCol.col.name].nf = result.nf;
					fs[tgtCellRowCol.row][tgtCellRowCol.col.name].value = value;
					fs[tgtCellRowCol.row][tgtCellRowCol.col.name].text = result.text;
					if (result.links) fs[tgtCellRowCol.row][tgtCellRowCol.col.name].links = result.links;
					ProcessRowColumn(tgtCellRowCol.col, fs[tgtCellRowCol.row]);
					fs[tgtCellRowCol.row][tgtCellRowCol.col.name].old = undefined;
					tgtCellRowCol = undefined;
					m.redraw();
				}
			}
		}
		//return result;
	}

	function CheckForUpdatingFields() {
		if (Object.keys(updatingfields) == 0) {
			waitforupdatingfields = false;
			m.redraw();
		}
	}

	function UpdateWSinDS(r) {
		if (r.action == "remove") {
			let wi = r.wi;
			for (let i = 0; i < ws.wilists[wi.__uid__].wilist.length; i++) {
				if (ws.wilists[wi.__uid__].wilist[i].iid == wi.iid) {
					ws.wilists[wi.__uid__].wilist.splice(i, 1);
					m.redraw();
				}
			}
		}

		if (r.action == "complete") {
			let wi = r.wi;
			for (let i = 0; i < ws.wilists[wi.__uid__].wilist.length; i++) {
				if (ws.wilists[wi.__uid__].wilist[i].iid == wi.iid) {
					ws.wilists[wi.__uid__].wilist[i].completed = true;
					ws.wilists[wi.__uid__].wilist[i].completedon = mmtjs().toDate().toISOString();
					m.redraw();
				}
			}
		}
	}

	let firstTime = true;

	function ListenForSearchCopyMessage() {
		document.addEventListener("copysearchparameter", (e) => {
			if (e && e.detail) updateFilter(e.detail.name, e.detail.filter);
		});
	}

	function SendSearchCopyMessage(name, filter) {
		document.dispatchEvent(new CustomEvent("copysearchparameter", {detail: {name, filter}}));
	}

	function TableFooterRenderingFunction(cols, ds, csum, ws, wstype, selectionFieldColumn, showrowdetail) {
		return m("tfoot", [
			m("tr", [
				selectionFieldColumn ? m("td") : null,
				cols
					.filter((a) => !a.hide)
					.map((c) => {
						let cs = ds.cols.filter((a) => a.name == c.name)[0];

						if (!!c.sum) {
							if (csum[c.name])
								return m(
									"td.sum",
									{
										class: (() => {
											return `${c.isNumber ? "colNumber" : ""}
                                    `
												.replace(/\n/g, " ")
												.replace(/\s+/g, " ");
										})(),
									},
									pf.ConvertToCommaSeparaterNumber(csum[c.name], c.customclass)
								);
							else
								return m(
									"td.sum",
									{
										class: (() => {
											return `${c.isNumber ? "colNumber" : ""}
                                    `
												.replace(/\n/g, " ")
												.replace(/\s+/g, " ");
										})(),
									},
									(cs && pf.ConvertToCommaSeparaterNumber(cs.sumvalue, c.customclass)) || 0
								);
						} else {
							return m("td");
						}
					}),
				ws
					? wstype < 10
						? ws.wslist.map((ws) => {
								return m("td");
						  })
						: m("td")
					: null,
				showrowdetail ? m("td") : null,
			]),
		]);
	}

	function TableHeaderRenderingFunction(
		tableInfo,
		cols,
		updateFilter,
		toggleSort,
		ws,
		wstype,
		wsTitlesSlanted,
		onclick,
		selectionFieldColumn,
		SendSearchCopyMessage,
		stripdata,
		showrowdetail
	) {
		return m(stripdata ? ".thead" : "thead", [
			tableInfo.showFilter
				? m("tr.p-table-search", [
						selectionFieldColumn
							? m(
									"th",
									{
										title: "Select Displayed Rows",
										style: `text-align: center;`,
										onclick: () => {
											selectedall = !selectedall;
											fs.forEach((r) => SelectCurrentRowValue(r.selectionid, selectedall));
										},
									},
									m(Icon, {name: selectedall ? Icons.X_CIRCLE : Icons.CHECK_CIRCLE})
							  )
							: null,
						cols
							.filter((a) => !a.hide)
							.map((h) => {
								// console.log({name: h.name, h});
								return m(
									"th.p-table-search",
									{
										onclick: (e) => {
											if (tools.GetModifiers(e).primary) {
												SendSearchCopyMessage(h.name, h.filter);
											} else {
												if (e.altKey) {
													updateFilter(h.name, null);
												} else {
													if (h.isBool) {
														if (h.filter != null) {
															if (h.filter) updateFilter(h.name, 0);
															else updateFilter(h.name, null);
														} else updateFilter(h.name, 1);
													}
												}
											}
										},
										title: "Ctrl+Click to copy across pages. Alt+Click to Clear",
										// onkeydown: e => {
										//     if (e.keyCode == 27) {
										//
										//         updateFilter(h.name, null);
										//
										//     }
										// },
										class: `${h.isFile ? "colFile" : ""} ${h.isImage ? "colImage" : ""}${h.isBool ? "colbool" : ""} ${
											h.isNumber ? "colnumber" : ""
										} ${h.isDate ? "coldate" : ""} ${h.filter ? "has-value" : ""}`.trim(),
									},
									!h.customformat && [
										h.isDate
											? m(datepicker, {
													options: {
														size: 1,
														mode: "range",
														showtime: h.isTime,
														value: h.filter,
														title: h.filter,
														OnUpdateEvent: (r) => {
															// console.log(r);
															updateFilter(h.name, r);
														},
													},
											  })
											: h.isBool
											? h.filter != null
												? h.filter
													? "Y"
													: "N"
												: null
											: m("input.p-table-search", {
													// placeholder: (h.isBool ? "1/0" : "search"),
													size: 1,
													title: h.isBool ? "True = 1 & False = 0" : h.filter || "Search this column by typing here",
													oninput: (e) => {
														updateFilter(h.name, e.target.value);
													},
													value: h.filter,
											  }),
									]
								);
							}),
						ws
							? wstype < 10
								? ws.wslist.map((ws) => {
										return m("th", {
											class: wsTitlesSlanted ? "workstep-title-tilted" : "workstep-title-straight",
										});
								  })
								: m("th")
							: null,

						showrowdetail ? m("th.p-table-search") : null,
				  ])
				: null,
			m("tr", [
				selectionFieldColumn
					? m(
							"th.p-column-header",
							{
								style: `width:${2}rem`,
							},
							"Select"
					  )
					: null,
				cols
					.filter((a) => !a.hide)
					.map((h) => {
						return m(
							"th.p-column-header",
							{
								title: "To sort, click on column. To hide/show columns, Ctrl+Click",
								onclick: (e) => {
									if (tools.GetModifiers(e).primary) {
										if (onclick) onclick(e, h);
									} else toggleSort(h.name);
								},
								class: (() => {
									return `${h.isNumber ? "colNumber" : ""}
                            `
										.replace(/\n/g, " ")
										.replace(/\s+/g, " ");
								})(),
							},
							[
								m("div.p-column-header", [
									m(".th-header", h.caption),
									m("span.icon", [
										h.sort == 1
											? m(svg, {
													name: "trending-down",
											  })
											: null,
										h.sort == -1
											? m(svg, {
													name: "trending-up",
											  })
											: null,
									]),
								]),
							]
						);
					}),
				ws
					? wstype < 10
						? ws.wslist.map((ws) => {
								return m(
									"th",
									{
										class: wsTitlesSlanted ? "workstep-title-tilted" : "workstep-title-straight",
										//width: (wstype == 2 ? `120px` : (wsTitlesSlanted ? undefined : `30px`)),
										//width: (wstype == 2 ? `120px` : (wsTitlesSlanted ? undefined : `30px`)),
										style: `width:${wstype == 2 ? 90 : 30}px`,
										onclick: onclick,
										title: ws.name,
									},
									[m("div", [m("span", ws.shortname || ws.name)])]
								);
						  })
						: m("th")
					: null,

				showrowdetail ? m("th.p-column-header") : null,
			]),
		]);
	}

	function ShowFirstTimeLoadingScreen() {
		return m("table.prasora-block-table", [
			m("thead", [m("tr", [m("th", "loading...")])]),
			m("tfoot", []),
			m("tbody", [m("tr", [m("td.fullheight", m(loader))])]),
		]);
	}

	return {
		oninit: (v) => {
			tid = v.attrs.tid;
			prid = v.attrs.prid;
			tact = v.attrs.tact;
			groups = v.attrs.groups;
			category = v.attrs.category;
			HasNoDataAction = v.attrs.onSetHasNoData;
			pagesize = v.attrs.defaultpagesize;
			appcode = v.attrs.appcode;
			hiddenFieldID = v.attrs.hiddenFieldID;
			hiddenFieldColumn = v.attrs.hiddenFieldColumn;
			selectsingleonly = v.attrs.selectsingle;
			showasfields = v.attrs.showasfields;
			stripdata = v.attrs.stripdata;
			firstTime = false;
			prefilter = v.attrs.prefilter;
			fixed_editable = v.attrs.fixed_editable;
			parentrow = v.attrs.row;
			refreshtime = v.attrs.refreshtime;
			cachetime = v.attrs.cachetime;

			//console.log("bck", {refreshtime: v.attrs.refreshtime, cachetime: v.attrs.cachetime});

			// console.log({row: v.attrs.row});
			if (v.attrs.row) isJuniorBlock = true;

			if (hiddenFieldColumn || v.attrs.row) Process();
			else
				GetDataFromCache().then((_) => {
					initialted = true;
					// console.log("4");
					Process();
				});

			if (fixed_editable) tableInfo.editable = true;

			ListenForSearchCopyMessage();
		},
		view: (v) => {
			if (showColumnOptions) {
				return m(
					modal,
					{
						title: "Column Management",
					},
					[]
				);
			} else if (showfilterOptions) {
				return m(
					modal,
					{
						title: "Filter Management",
					},
					[m("h1", "Filter Management Area")]
				);
			} else if (showShareOptions) {
				return m(
					modal,
					{
						title: "Share Management",
					},
					[m("h1", "Share Management Area")]
				);
			} else {
				if (tableInfo.stateReady) {
					return m(
						stripdata ? ".prasora-block-table-wrapper-stripped" : ".prasora-block-table-wrapper",
						{
							class: tableInfo.stateLoading ? "data-loading" : null,
						},
						[
							cols.some((a) => a.hide) ? m(".hidden-columns-indicator", [m(Icon, {name: Icons.COLUMNS})]) : null,
							(!hideHeader && !showasfields) || tableInfo.showEditable
								? m(
										".table-header",

										[
											m(
												".table-header-page-wrapper",
												!hideHeader && !showasfields && tableInfo.showFilter
													? [
															m(
																"span.icon-btn.page-size",
																{
																	onclick: () => {
																		if (pagesize == 5) {
																			pagesize = 10;
																			DelayedRefresh(true);
																		} else if (pagesize == 10) {
																			pagesize = 20;
																			DelayedRefresh(true);
																		} else {
																			pagesize = 5;
																			DelayedRefresh(true);
																		}
																	},
																	title: "Click to change page size",
																},
																Math.min(pagesize, ds.count)
															),
															m(
																"span.icon-btn",
																{
																	onclick: PageDecrease,
																	title: "Previous Page",
																},
																m(svg, {
																	name: "arrow-left-circle",
																})
															),
															m("span.page-detail", [
																m("span.first-part", `Page `),
																m("input.current-page-number", {
																	// disabled: true,
																	value: tempPageNumber,
																	size: 1,
																	oninput: (e) => {
																		tempPageNumber = e.target.value;
																		let t = e.target.value.match(/^-?\d*(\.\d+)?$/);
																		if (t) {
																			t = parseInt(e.target.value);
																			if (t) tempPageNumber = t;
																			DirectSetPageNum();
																		}
																	},
																	onblur: (e) => {
																		if (!tempPageNumber) tempPageNumber = pagenum;
																	},
																}),
																m("span.second-part", ` of ${noOfPages} (${numberOfRows} records)`),
															]),
															m(
																"span.icon-btn",
																{
																	onclick: PageIncrease,
																	title: "Next Page",
																},
																m(svg, {
																	name: "arrow-right-circle",
																})
															),
															m(
																"span.icon-btn.loading",
																{
																	onclick: () => {
																		Refresh(false, false);
																	},
																	title: "Refresh",
																},
																m(
																	".rotating-icon", //, {class: tableInfo.stateLoading ? "spin" : undefined}
																	[
																		tableInfo.stateLoading
																			? m(standardLoader)
																			: m(svg, {
																					name: "rotate",
																			  }),
																	]
																)
															),
															selectsingleonly
																? undefined
																: currentlySelectedRows.size > 0
																? m("span.icon-btn", `${currentlySelectedRows.size} items selected`)
																: null,
													  ]
													: m("span")
											),
											m(".table-header-button-wrapper", [
												// m("span.icon-btn", {
												//     onclick: () => {
												//         showShareOptions = true;
												//     },
												//     title: "Share Table"
												// }, m(svg, {
												//     name: "share"
												// })),
												// tableInfo.showFilter ? m("span.icon-btn", {
												//     onclick: () => {
												//         showfilterOptions = true;
												//     },
												//     title: "Manage Filters"
												// }, m(svg, {
												//     name: "sliders"
												// })) : null,
												tableInfo.showEditable && !fixed_editable
													? tableInfo.editable
														? waitforupdatingfields
															? m(Btn, {
																	label: "Updating",
																	small: true,
																	minwidth: "12ch",
																	loading: true,
																	title: "Updating Data",
																	onclick: () => {
																		alert("Please wait. We are updating data on backend.");
																	},
															  })
															: // m(
															  // 		"span.icon-btn.icon-text-button.edit-icon",
															  // 		{
															  // 			onclick: () => {
															  // 				alert("Please wait. We are updating data on backend.");
															  // 			},
															  // 			title: "Updating Data",
															  // 		},
															  // 		[
															  // 			m("span.icon-button-text", "Updating"),
															  // 			m(svg, {
															  // 				name: "loader",
															  // 			}),
															  // 		]
															  //   )
															  m(Btn, {
																	label: "DONE",
																	small: true,
																	loading: false,
																	minwidth: "12ch",
																	title: "Click here to disable editing",
																	iconLeft: Icons.ROTATE_CW,
																	onclick: () => {
																		tableInfo.editable = false;
																		Refresh(false, false);
																	},
															  })
														: //   }) m(
														  // 		"span.icon-btn.icon-text-button.edit-icon",
														  // 		{
														  // 			onclick: () => {
														  // 				tableInfo.editable = false;
														  // 				Refresh(false, false);
														  // 			},
														  // 			title: "Click here to disable editing",
														  // 		},
														  // 		[
														  // 			m("span.icon-button-text", "DONE"),
														  // 			m(svg, {
														  // 				name: "refresh-cw",
														  // 			}),
														  // 		]
														  //   )
														  m(Btn, {
																label: "EDIT",
																loading: false,
																small: true,
																minwidth: "12ch",
																title: "Edit Data",
																iconLeft: Icons.EDIT,
																onclick: () => {
																	tableInfo.editable = true;
																},
														  })
													: // 	  m(
													  // 		"span.icon-btn.icon-text-button.edit-icon",
													  // 		{
													  // 			onclick: () => {
													  // 				tableInfo.editable = true;
													  // 			},
													  // 			title: "Edit Data",
													  // 		},
													  // 		[
													  // 			m("span.icon-button-text", "EDIT"),
													  // 			m(svg, {
													  // 				name: "edit",
													  // 			}),
													  // 		]
													  //   )
													  null,
												ds.allowexport
													? m(Btn, {
															label: "Download Table",
															small: true,
															loading: downloadingtable,
															iconLeft: Icons.DOWNLOAD,
															onclick: () => {
																if (numberOfRows <= maxRowsExportable) {
																	if (!downloadingtable) {
																		downloadingtable = true;
																		m.redraw();
																		DownloadTable().then(() => {
																			downloadingtable = false;
																			m.redraw();
																		});
																	}
																} else {
																	alert(
																		`You cannot export more than ${maxRowsExportable} rows. Please use better filters. For Bulk Download options, contact Prasora Team`
																	);
																}
															},
													  })
													: // 	  m(
													  // 		"span.icon-btn.icon-text-button",
													  // 		{
													  // 			onclick: () => {
													  // 				if (numberOfRows <= maxRowsExportable) {
													  // 					if (!downloadingtable) {
													  // 						downloadingtable = true;
													  // 						m.redraw();
													  // 						DownloadTable().then(() => {
													  // 							downloadingtable = false;
													  // 							m.redraw();
													  // 						});
													  // 					}
													  // 				} else {
													  // 					alert(
													  // 						`You cannot export more than ${maxRowsExportable} rows. Please use better filters. For Bulk Download options, contact Prasora Team`
													  // 					);
													  // 				}
													  // 			},
													  // 			title: "Download Table",
													  // 		},
													  // 		[
													  // 			m("span.icon-button-text", downloadingtable ? "..." : "Export"),
													  // 			downloadingtable &&
													  // 				m(svg, {
													  // 					name: "loader",
													  // 				}),
													  // 			!downloadingtable &&
													  // 				m(svg, {
													  // 					name: "download",
													  // 				}),
													  // 		]
													  //   )
													  null,
												ds.allowexport
													? m(Btn, {
															label: "Copy Table",
															small: true,
															loading: downloadingtable,
															iconLeft: Icons.COPY,
															onclick: () => {
																if (numberOfRows <= maxRowsExportable) {
																	if (!downloadingtable) {
																		downloadingtable = true;
																		m.redraw();
																		CopyTable().then(() => {
																			downloadingtable = false;
																			m.redraw();
																		});
																	}
																} else {
																	alert(
																		`You cannot copy more than ${maxRowsExportable} rows. Please use better filters. For Bulk Download options, contact Prasora Team`
																	);
																}
															},
													  })
													: //   m(
													  // 		"span.icon-btn.icon-text-button",
													  // 		{
													  // 			onclick: () => {
													  // 				if (numberOfRows <= maxRowsExportable) {
													  // 					if (!downloadingtable) {
													  // 						downloadingtable = true;
													  // 						m.redraw();
													  // 						CopyTable().then(() => {
													  // 							downloadingtable = false;
													  // 							m.redraw();
													  // 						});
													  // 					} else {
													  // 						alert(
													  // 							`You cannot copy more than ${maxRowsExportable} rows. Please use better filters. For Bulk Download options, contact Prasora Team`
													  // 						);
													  // 					}
													  // 				}
													  // 			},
													  // 			title: "Copy Table",
													  // 		},
													  // 		[
													  // 			m("span.icon-button-text", downloadingtable ? "..." : "Copy"),

													  // 			downloadingtable &&
													  // 				m(svg, {
													  // 					name: "loader",
													  // 				}),
													  // 			!downloadingtable &&
													  // 				m(svg, {
													  // 					name: "copy",
													  // 				}),
													  // 		]
													  //   )
													  null,
												// m("span.icon-btn", {
												//     onclick: () => {
												//         showColumnOptions = true;
												//     },
												//     title: "Modify Columns"
												// }, m(svg, {
												//     name: "grid"
												// })),
												// m(
												// 	"span.icon-btn",
												// 	{
												// 		onclick: toggleFilter,
												// 		title: tableInfo.showFilter ? "Hide filter" : "Show filter",
												// 	},
												// 	m(svg, {
												// 		name: tableInfo.showFilter ? "no-filter" : "filter",
												// 	})
												// ),
											]),
										]
								  )
								: null,
							m(".table-wrapper", [
								m(
									stripdata ? ".table.prasora-block-table" : "table.prasora-block-table",
									{
										class: classnames(
											{"show-as-fields": showasfields},
											{"hide-header": hideHeader},
											{"show-header": !hideHeader}
										),
										cellpadding: 0,
									},
									[
										hideHeader
											? null
											: TableHeaderRenderingFunction(
													tableInfo,
													cols,
													updateFilter,
													toggleSort,
													ws,
													wstype,
													wsTitlesSlanted,
													(e, h) => {
														if (e.shiftKey) {
															//admin functions
															helper.Reset();
															askbar.AskCustom(
																`Set Caption & Width for ${h.name}`,
																undefined,
																{
																	Confirm: () => {
																		// console.log("before", {h});
																		h.caption = helper.Data.caption;
																		h.width = helper.Data.width;
																		h.format = helper.Data.customformat;
																		// console.log("after", {h});
																		// helper.Reset();
																		askbar.ShowCornerIcon();
																	},
																},
																{
																	Cancel: () => {
																		helper.Reset();
																	},
																},
																() => {
																	return m(".wrapper", [
																		helper.Label(
																			"Caption",
																			helper.Input(h.caption, {
																				oninput: (e) => {
																					helper.Data.caption = e.target.value;
																					h.caption = e.target.value;
																				},
																			})
																		),
																		helper.Label(
																			"Width",
																			helper.Input(h.width, {
																				oninput: (e) => {
																					helper.Data.width = e.target.value;
																					h.width = e.target.value;
																				},
																			})
																		),
																		helper.Label("Format", undefined, undefined, undefined, () => {
																			return helper.SelectSimple(h.format, FunctionList(), (val) => {
																				// console.log({val});
																				if (val) helper.Data.customformat = val.id;
																				else helper.Data.customformat = undefined;
																			});
																		}),
																	]);
																}
															);
														} //No Admin Functions
														else
															askbar.AskCustom(
																"Show/Hide Columns",
																m(
																	".col-list",
																	{
																		style: "display: flex; flex-direction: row; flex-wrap: wrap; gap: 1rem;",
																	},
																	cols.map((h, i) => {
																		return m(
																			"label",
																			{
																				style: `display: grid; grid-template-columns: auto 1fr; gap: 0.5rem; width: 40ch;
																		border: 1px solid lightgray; border-radius: 0.25rem; padding: 0.5rem 1rem; position: relative;`,
																				//bgcolor: h.hide ? "white" : "lightgreen",
																			},

																			[
																				m("input", {
																					type: "checkbox",
																					//style: "position: absolute; left: -100vw;",
																					checked: !h.hide,
																					onchange: (e) => {
																						hiddenCols[h.name] = !e.target.checked;
																						cols[i].hide = !e.target.checked;
																						// console.log({cols});
																					},
																				}),
																				m("span", h.caption),
																			]
																		);
																	})
																),
																{Confirm: () => {}},
																{Cancel: () => {}}
															);
													},
													hiddenFieldColumn,
													SendSearchCopyMessage,
													stripdata,
													showrowdetail
											  ),
										showfoot
											? TableFooterRenderingFunction(cols, ds, csum, ws, wstype, hiddenFieldColumn, showrowdetail)
											: null,

										m(
											stripdata ? ".tbody" : "tbody",
											{
												// key: v.attrs.key + pagenum
											},
											[
												fs.map((r, ri) => {
													// console.log(r, hiddenFieldColumn);
													let row = undefined;
													if (juniors) {
														row = Object.keys(r).reduce((p, c) => {
															p[c] = r[c].value;
															return p;
														}, {});

														// console.log({r, row});
													}

													return m(
														stripdata ? ".tr" : "tr",
														{
															key: r.__uid__,
														},
														[
															hiddenFieldColumn
																? m(
																		"td",
																		{
																			style: `vertical-align: middle; text-align: center;`,
																		},
																		[
																			r.selectionid &&
																				m(cb, {
																					onchange: (e) => {
																						SelectCurrentRowValue(r.selectionid, e.target.checked);
																					},
																					value: currentlySelectedRows.has(r.selectionid),
																				}),
																		]
																  )
																: null,
															cols
																.filter((a) => !a.hide)
																.map((h, ci) => {
																	let uid = r.__uid__;
																	if (!uid) uid = Date.now();
																	let key = `${uid}${h.name}${tableInfo.editable}${ri}`; //${r[h.name].nf}
																	// h.customformat && console.log("bck", h.customformat);

																	// console.log({ri, col: h.name, value: r[h.name].value});

																	let juniors = undefined;
																	if (tableInfo.editable && r[h.name].nf && !h.customformat)
																		juniors = m(".editable-cell-wrapper", [
																			m(tc, {
																				stripdata,
																				col: h,
																				tact: tact,
																				colindex: ci,
																				value: r[h.name].value,
																				text: r[h.name].text,
																				updating: r[h.name].updating,
																				links: r[h.name].links,
																				nf: r[h.name].nf,
																				nfd: r[h.name].nfd,
																				editable: true,
																				key,
																				//headercontent: ,
																				UpdateField: UpdateField,
																				customclass: r[h.name].customclass,
																				customwidth: r[h.name].customwidth,
																				hover: r[h.name].hover,
																				morecontent: r[h.name].morecontent,
																				reportlink: r[h.name].reportlink,
																			}),
																		]);
																	// console.log({
																	// 	nfd: r[h.name].nfd,
																	// 	col: h.name,
																	// 	c: r[h.name],
																	// 	ri,
																	// 	ci,
																	// 	h,
																	// });
																	return [
																		m(tc, {
																			stripdata,
																			col: h,
																			tact: tact,
																			colindex: ci,
																			value: r[h.name].value,
																			text: r[h.name].text,
																			updating: r[h.name].updating,
																			links: r[h.name].links,
																			nf: r[h.name].nf,
																			nfd: r[h.name].nfd,
																			// eslint-disable-next-line no-constant-binary-expression
																			editable: false || (h.customformat && tableInfo.editable && r[h.name].nf),
																			key,
																			//headercontent: ,
																			UpdateField: UpdateField,
																			customclass: r[h.name].customclass,
																			customwidth: r[h.name].customwidth,
																			hover: r[h.name].hover,
																			morecontent: r[h.name].morecontent,
																			juniors,
																			reportlink: r[h.name].reportlink,
																			customformat: h.customformat,
																		}),
																	];
																}),
															ws
																? wstype < 10
																	? ws.wslist.map((wsp) => {
																			if (wstype == 1) {
																				let wis = ws.wilists[r.__uid__].wilist.filter((i) => {
																					return i.wid == wsp.id;
																				});

																				return m("td", [
																					wis.map((wi) => {
																						return m(wsi, {
																							ws: wsp,
																							wi: wi,
																							wslist: ws.wslist,
																							previous: wi.previous,
																							next: wi.next,
																						});
																					}),
																				]);
																			}

																			if (wstype == 2 || wstype == 3) {
																				let wis = ws.wilists[r.__uid__].wilist.filter((i) => {
																					return i.wid == wsp.id;
																				});

																				let isDue = wis.filter((a) => a.isdue && !a.completed).length > 0;
																				let comments = wis
																					.filter((a) => !!a.remarks)
																					.map((a) => `${a.name}\r\n${a.remarks}\r\n------------`)
																					.join("\r\n");

																				if (wis.length > 0) {
																					return m(
																						"td",
																						{
																							class: `td-wsi-${wstype}`,
																							title: comments,
																						},
																						[
																							m(wsi2, {
																								isDue: isDue,
																								fullwsi: ws.wilists[r.__uid__],
																								ws: wsp,
																								wslist: ws.wslist,
																								wis: wis,
																								UpdateWSinDS: UpdateWSinDS,
																								wstype: wstype,
																							}),
																						]
																					);
																				} else {
																					return m("td");
																				}
																			}
																	  })
																	: m("td")
																: null,

															showrowdetail
																? m(
																		"td",
																		{
																			style: `text-align: center; width: 3em;`,
																		},
																		[
																			m(PopoverMenu, {
																				closeOnContentClick: true,
																				content: [
																					juniors
																						.filter((j) => j.type == "Block")
																						.map((j) => {
																							return m(MenuItem, {
																								iconLeft: Icons.EXTERNAL_LINK,
																								label: j.blocktitle || "Detail",
																								onclick: () => {
																									askbar.AskCustom(
																										j.blocktitle || "Detail",
																										undefined,
																										undefined,
																										undefined,
																										() => {
																											return m(popupblock, {
																												tid: j.tid,
																												category: j.category,
																												prid: j.prid,
																												blockcode: j.blockcode,
																												appcode: j.appcode,
																												defaultpagesize: j.defaultpagesize,
																												showasfields: j.showasfields,
																												stripdata: j.stripdata,
																												fixed_editable: j.fixed_editable,
																												row,
																											});
																										}
																									);
																								},
																							});
																						}),
																					[...new Set(juniors.map((j) => j.type))].length == 2 && m(MenuDivider),

																					juniors
																						.filter((j) => j.type == "CustomActionButton")
																						.map((j) => {
																							// console.log({row, cols});
																							return j.buttonlist.map((b) => {
																								return m(MenuItem, {
																									iconLeft: Icons.PLAY,
																									label: b.caption,
																									onclick: async () => {
																										// clickedsection = true;

																										return await cac.RunFunction(async () => {
																											let result = await pf.APIAction(j.apicode, {
																												appcode: j.appcode,
																												id: b.id,
																												type: b.type,
																												bdr: b.bdr,
																												row,
																											});

																											if (result.success) location.reload();
																											if (result)
																												return {
																													success: result.success,
																													message: result.success ? "Refreshing..." : result.error,
																												};
																											// return {success: true};
																										});
																									},
																								});
																							});
																						}),
																				],
																				menuAttrs: {size: Size.SM},
																				position: "left",
																				openOnTriggerFocus: true,
																				hoverOpenDelay: 200,
																				interactionType: "hover",
																				trigger: m(Button, {iconLeft: Icons.LIST, size: Size.SM}),
																			}),
																		]
																  )
																: null,
														]
													);
												}),
											]
										),
									]
								),
							]),
							!showasfields && m(".table-footer"),
							m(askbarcomp),
							cac.overlay(),
						]
					);
				} else return ShowFirstTimeLoadingScreen();
			}
		},
	};
};

export default bck;
